import {
	newGoalForm
} from "../forms";

export const pristineState = i18n => ( {
	selectedPanel: "details",
	/** formId.fieldName:startPosition **/
	focusedField: "",
	myTeams: [],
	isBusy: false,
	isDisabled: false,
	saveAttempted: false,
	goalForm: newGoalForm( {}, i18n ),
	keyResultForms: [],
	goalActivity: [],
	activityComment: "",
} );

